import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center py-16 px-5" data-testid="login-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E3E8E8] shadow-soft p-8">
        <Link to="/"><Logo /></Link>
        <h1 className="font-display font-extrabold text-3xl text-[#0B1733] mt-6">Welcome back</h1>
        <p className="text-[#4A5568] mt-1 text-sm">Log in to manage your jobs, quotes and messages.</p>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" className="mt-1.5 h-11" placeholder="you@example.com" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" className="mt-1.5 h-11" placeholder="••••••••" />
          </div>
          {err && <p className="text-sm text-red-600" data-testid="login-error">{err}</p>}
          <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full h-11 rounded-full bg-[#007F83] hover:bg-[#006B70] text-white">
            {loading ? "Logging in..." : "Log in"}
          </Button>
        </form>
        <div className="mt-5 flex justify-between text-sm">
          <Link to="/forgot-password" className="text-[#007F83] font-medium hover:underline" data-testid="forgot-link">Forgot password?</Link>
          <Link to="/register" className="text-[#0B1733] font-medium hover:text-[#007F83]" data-testid="to-register-link">Create an account</Link>
        </div>
      </div>
    </div>
  );
}
